const styles = theme => {
  const minMd = theme.breakpoints.up('md');

  return {
    firstRow: {
      [minMd]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    secondRow: {
      extend: 'firstRow',
      paddingTop: '30px',
    },
    fieldsGroupOne: {
      marginBottom: 30,
      [minMd]: {
        marginBottom: 0,
        width: '38%',
      },
    },
    fieldsGroupTwo: {
      [minMd]: {
        width: '60%',
      },
    },
  };
};

export default styles;
